"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var assetsActions = _interopRequireWildcard(require("../assets/actionTypes"));
var _objects = require("../../utils/objects");
var _assets = require("../../utils/assets");
var actions = _interopRequireWildcard(require("./actionTypes"));
var utils = _interopRequireWildcard(require("./utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {}
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var minorPath = (0, _assets.getGAMKey)(action);
  var gaPath = (0, _assets.getGAKey)(action);
  switch (action.type) {
    case actions.CREATE_REVIEW.REQUEST:
      {
        var _state$data$minorPath, _state$data$minorPath2;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            comments: [action.review].concat((_state$data$minorPath = (_state$data$minorPath2 = state.data[minorPath]) === null || _state$data$minorPath2 === void 0 ? void 0 : _state$data$minorPath2.comments) !== null && _state$data$minorPath !== void 0 ? _state$data$minorPath : [])
          }))
        });
      }
    case assetsActions.DELETE_ASSET.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread({}, (0, _objects.omit)(state.data, minorPath))
        });
      }
    case assetsActions.CREATE_ASSET.SUCCESS:
    case assetsActions.FETCH_ASSET.SUCCESS:
      {
        var _state$data$minorPath3, _state$data$minorPath4;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            rating: action.asset.rating,
            numberOfRates: action.asset.numberOfRates,
            comments: (_state$data$minorPath3 = (_state$data$minorPath4 = state.data[minorPath]) === null || _state$data$minorPath4 === void 0 ? void 0 : _state$data$minorPath4.comments) !== null && _state$data$minorPath3 !== void 0 ? _state$data$minorPath3 : null
          }))
        });
      }
    case actions.REPLACE_REVIEW:
      {
        var _state$data$minorPath5;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            comments: (_state$data$minorPath5 = state.data[minorPath]) === null || _state$data$minorPath5 === void 0 ? void 0 : _state$data$minorPath5.comments.map(function ($review) {
              return $review.id === action.tempId ? _objectSpread(_objectSpread({}, $review), {}, {
                id: action.review.id
              }) : $review;
            })
          }))
        });
      }
    case actions.FETCH_REVIEWS.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            rating: action.reviews.rating,
            numberOfRates: action.reviews.numberOfRates,
            comments: action.reviews.comments
          }))
        });
      }
    case actions.CREATE_REVIEW.FAILURE:
    case actions.DELETE_REVIEW.REQUEST:
      {
        var _state$data$minorPath6;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            comments: (((_state$data$minorPath6 = state.data[minorPath]) === null || _state$data$minorPath6 === void 0 ? void 0 : _state$data$minorPath6.comments) || []).filter(function (review) {
              return review.id !== action.id;
            })
          }))
        });
      }
    case actions.EDIT_REVIEW.REQUEST:
      {
        var _state$data$minorPath7;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, minorPath, {
            comments: (_state$data$minorPath7 = state.data[minorPath]) === null || _state$data$minorPath7 === void 0 ? void 0 : _state$data$minorPath7.comments.map(function (review) {
              return review.id === action.reviewToUpdate.id ? action.reviewToUpdate : review;
            })
          }))
        });
      }
    case actions.UPDATE_RATING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread({}, utils.updatePropertyToAllVersions(gaPath, state, {
            rating: null,
            numberOfRates: null
          }))
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map